import $ from 'jquery';
import bindEvent from '../../scripts/util/bindEvent';
import {TweenMax} from 'TweenMax';
import Power2 from 'animation.gsap';
import 'scrollTo';

const selectors = {
	scrollToTop: '.js-scroll-to-top',
	scrollToSupport: '.js-scroll-to-support'
};

const scroll = coord => {

	const a = () => {
		TweenMax.to(window, 2, {
			scrollTo: {y: coord, autoKill: false},
			ease: Power2.easeInOut
		});
	};

	return a;
};

const render = () => {
	bindEvent(selectors.scrollToTop, 'click', scroll(0));
	if ( $('.js-beside-trigger').length ) {
		bindEvent(selectors.scrollToSupport, 'click', scroll($('.js-beside-trigger').offset().top));
	}
};

export default render;
